(function () {
  function getMobileMenuDrawer() {
    return document.getElementById("mobile-menu-drawer");
  }

  function isMenuOpen(drawer) {
    if (!drawer) return false;
    return drawer.getAttribute("aria-hidden") === "false" || drawer.classList.contains("open");
  }

  function setAllBehind(drawer, enabled) {
    if (!drawer) return;

    // כל מה שנמצא בתוך body חוץ מהתפריט עצמו
    var elements = Array.from(document.body.children).filter(function (el) {
      return el !== drawer && el.id !== "shopify-section-header";
    });

    elements.forEach(function (el) {
      if (enabled) {
        el.dataset.originalPointer = el.style.pointerEvents || "";
        el.dataset.originalZ = el.style.zIndex || "";
        el.style.pointerEvents = "none";
        el.style.zIndex = "0";
      } else {
        if (el.dataset.originalPointer !== undefined) {
          el.style.pointerEvents = el.dataset.originalPointer;
          delete el.dataset.originalPointer;
        }
        if (el.dataset.originalZ !== undefined) {
          el.style.zIndex = el.dataset.originalZ;
          delete el.dataset.originalZ;
        }
      }
    });

    // התפריט עצמו תמיד למעלה
    drawer.style.zIndex = enabled ? "999999" : "";
    drawer.style.position = enabled ? "fixed" : "";
  }

  function apply() {
    if (window.innerWidth > 1024) return;

    var drawer = getMobileMenuDrawer();
    if (!drawer) return;

    if (isMenuOpen(drawer)) {
      setAllBehind(drawer, true);
    } else {
      setAllBehind(drawer, false);
    }
  }

  // מעקב שינוי מאפיינים בתפריט עצמו
  var drawer = getMobileMenuDrawer();
  if (drawer) {
    var observer = new MutationObserver(apply);
    observer.observe(drawer, { attributes: true, attributeFilter: ["class", "aria-hidden"] });
  }

  // מעקב שינוי על body למקרה שהתבנית עובדת דרך classes
  var bodyObserver = new MutationObserver(apply);
  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });

  // ריצה ראשונית
  window.addEventListener("load", apply);
  window.addEventListener("resize", apply);
})();
